import { Field, ID, ObjectType } from 'type-graphql'
import { Contact } from '../contact/Contact'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@modelOptions({
  schemaOptions: {
    timestamps: true,
    strict: false,
  },
})
export class Tenant {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('ten') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  code: string

  @Field(() => String)
  @Prop({ type: String })
  name: string

  @Field(() => Contact)
  @Prop({ type: Contact })
  contact?: Contact

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  licenseNo?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  remarks?: string

  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  timeZone?: string
}
